import { Link, LinkProps } from '@mui/material';

export default function TermsOfUseLink(props: LinkProps) {
  return (
    <Link href="https://www.verifime.com/terms" target="_blank" {...props}>
      Terms of Use
    </Link>
  );
}
